import {
  E_PAYMENT_GET_SERVICE_TERMINAL_ID_SUCCESS,
  E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS,
  E_PAYMENT_GET_SERVICE_TERMINAL_ID,
} from "actions";

export const e_payment = (previousState = {}, { type, payload }) => {
  if (type === E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS) {
    return payload;
  } else if (type === E_PAYMENT_GET_SERVICE_TERMINAL_ID) {
    return { ...previousState, service_terminal_ids: [] };
  } else if (type === E_PAYMENT_GET_SERVICE_TERMINAL_ID_SUCCESS) {
    return { ...previousState, service_terminal_ids: payload.data};
  }

  return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/e_payment/index.js